import { useRef } from 'react';
import { ThemeType } from '../../../utils/type';
import './Layout.css';

interface LayoutProps {
  theme: ThemeType;
  children: React.ReactNode;
}

const Layout = ({
  theme = ThemeType.Direct,
  children,
}: LayoutProps): JSX.Element => {
  const prevThemeRef = useRef<string>();
  if (prevThemeRef.current !== theme) {
    document.documentElement.setAttribute('data-theme', theme);
    prevThemeRef.current = theme;
  }

  return <>{children}</>;
};

export default Layout;
